import { ReactElement, useEffect, useState } from 'react'
import { Container, Navbar, Nav, Button } from 'react-bootstrap'
import { signOut } from 'next-auth/react'
import Image from 'next/image'
import { User } from '@payload-types'
import NavDropdown from '@components/nav/navbar'
import { getConstant } from '@utils/constants'
import { getWorkspaceGroups } from '@utils/groups'
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline'
import API_Client from '@services/api-client'
import type { MenuApp } from '@pages/api/menu/apps'

interface NavBarProps {
  user: User;
}

export default function NavBar({ user }: NavBarProps): ReactElement {
  const [ apps, setApps ] = useState<MenuApp[]>([]);

  useEffect(() => {
    API_Client().get('menu/apps').then(({ success, data }) => {
      if (success && Array.isArray(data)) {
        setApps(data);
      }
    });
  }, []);

  return (
    <Navbar bg="primary" data-bs-theme="dark" expand="lg">
      <Container className="container-fluid">
        <Navbar.Brand href="/" className="p-0">
          <Image src="/images/logo-branca.svg" height={28} width={168} alt={getConstant('sitename')} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="flex-grow-1 align-items-center justify-content-end">
            <Nav.Link href="/novidades">Novidades</Nav.Link>
            <NavDropdown title="Documentos">
              <NavDropdown.Item href="/arquivos">Arquivos</NavDropdown.Item>
              <NavDropdown.Item href="/normativos-internos">Normativos Internos</NavDropdown.Item>
              <NavDropdown.Item href="/informativos-rh">Informativos RH</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Tarefas" user={user}>
              <NavDropdown.Item href="/processos">Processos</NavDropdown.Item>
              <NavDropdown.Item groups={ getWorkspaceGroups() } href="/workspace">Hub</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Apps" user={user}>
              <NavDropdown.Item href="/apps/dashboard">Minhas Aplicações</NavDropdown.Item>
              { apps.length > 0 && <NavDropdown.Divider /> }
              { apps.map(({ name, href }, i) => (
                <NavDropdown.Item key={i} href={href} target="_blank">{ name } <ArrowTopRightOnSquareIcon className="ms-2" /></NavDropdown.Item>
              )) }
            </NavDropdown>
            <NavDropdown title="Relatórios" user={user}>
              <NavDropdown.Item href="https://dashboard.fortesec.com.br" target="_blank">
                Dashboard <ArrowTopRightOnSquareIcon className="ms-2" />
              </NavDropdown.Item>
            </NavDropdown>
            <Button className="ms-2" variant="danger" size="sm" onClick={() => signOut({redirect: false})}>
              SAIR
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
